import { useMemo } from 'react';
import { enableAIConfigsJudgeEvals } from '@gonfalon/dogfood-flags/dogfood-flags';

import { type AiConfigModeOption, getAiConfigModes } from '../constants';

/**
 * Hook that returns the available AI Config modes based on feature flags.
 * This centralizes the logic for filtering modes, ensuring consistency
 * between tabs and filter dialogs.
 */
export function useAvailableModes(): readonly AiConfigModeOption[] {
  const isJudgeEnabled = enableAIConfigsJudgeEvals();

  return useMemo(
    () =>
      getAiConfigModes().filter((mode) => {
        if (mode.id === 'judge') {
          return isJudgeEnabled;
        }
        return true; // 'all', 'completion', and 'agent' are always available
      }),
    [isJudgeEnabled],
  );
}
